import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=0d3baa6f&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=js&"
export * from "./Forget.vue?vue&type=script&lang=js&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=0d3baa6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3baa6f",
  null
  
)

export default component.exports